export default __webpack_public_path__ + "d2c3bfa75ff259af5d7fc2e4fa123569.svg";